export const LOAD_WITHDRAWS_LIST = 'LOAD_WITHDRAWS_LIST';
export const ADD_WITHDRAW = 'ADD_WITHDRAW';
export const CONFIRM_WITHDRAW = 'CONFIRM_WITHDRAW';
export const RESTART_WITHDRAW = 'RESTART_WITHDRAW';
export const BUMP_WITHDRAW = 'BUMP_WITHDRAW';
export const CANCEL_WITHDRAW = 'CANCEL_WITHDRAW';
export const RESET_WITHDRAWS = 'RESET_WITHDRAWS';
